module.exports = __webpack_public_path__ + "static/media/IncreasingPositiveAttitude.3c99647b.mp3";